import { render, staticRenderFns } from "./IdeaPlayer.vue?vue&type=template&id=19c011b6"
import script from "./IdeaPlayer.vue?vue&type=script&lang=js"
export * from "./IdeaPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports